/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import { LOAD_DROPDOWN, LOAD_EMPLOYEE } from "./constants";

import {
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadDropdownSuccess,
  loadDropdownError,
} from "./actions";

import { loadEmployeeDetails, loadDropdownAPI } from "./remotes";

function* loadEmployeeSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadEmployee(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeDetails, searchFilter);
        if (result) {
          yield put(loadEmployeeSuccess(result));
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDropdownSaga() {
  while (true) {
    yield race({
      metaData: take(LOAD_DROPDOWN),
    });

    try {
      const city = yield call(loadDropdownAPI, "city", "post");
      const department = yield call(loadDropdownAPI, "dept", "post");
      const designation = yield call(loadDropdownAPI, "allDesign", "post");
      const state = yield call(loadDropdownAPI, "state", "post");
      const role = yield call(loadDropdownAPI, "allrole", "post");
      const loginShift = yield call(loadDropdownAPI, "allshift", "post");
      const employeeType = yield call(loadDropdownAPI, "emptype", "post");

      let dropDownList = {
        cityOptions:
          (city &&
            city.result &&
            city.result.length > 0 &&
            city.result
              .filter(c => c.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.cityName,
                    value: c._id,
                    stateId:c.stateName?._id
                  }
                )
              )) ||
          [],
        stateOptions:
          (state &&
            state.result &&
            state.result.length > 0 &&
            state.result
              .filter(f => f.status === 1).map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.stateName,
                    value: c._id,
                  }
                )
              )) ||
          [],

        roleOptions:
          (role &&
            role.roles &&
            role.roles.length > 0 &&
            role.roles
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.role,
                    value: c._id,

                  }
                )
              )) ||
          [],
        designationOptions:
          (designation &&
            designation.result &&
            designation.result.length > 0 &&
            designation.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.designationName,
                    value: c._id,
                    departmentId: c.departmentId._id
                  }
                )
              )) ||
          [],
        departmentOptions:
          (department &&
            department.result &&
            department.result.length > 0 &&
            department.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.departmentName,
                    value: c._id,

                  }
                )
              )) ||
          [],
        loginShiftOptions:
          (loginShift &&
            loginShift.result &&
            loginShift.result.length > 0 &&
            loginShift.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.shiftName,
                    value: c._id,

                  }
                )
              )) ||
          [],
        employeeTypeOptions:
          (employeeType &&
            employeeType.result &&
            employeeType.result.length > 0 &&
            employeeType.result
              .filter(f => f.status === 1 )
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.employeeType,
                    value: c._id,

                  }
                )
              )) ||
          [],
      };

      console.log(dropDownList, "dropdownSaga");

      yield put(loadDropdownSuccess(dropDownList));
    } catch (error) {
      yield put(
        loadDropdownError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}
export default function* recordsSaga() {
  yield all([loadEmployeeSaga(), loadDropdownSaga()]);
}
